import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addEvent from './component/addEvent.vue';
import addCancle from './component/addCancle.vue';
import addManage from './component/addManage.vue';
import signUpTeamList from './component/signUpTeamList.vue';
import { loadMoreList, commonData } from "@/mixins/index";
export default {
  name: "eventlist",
  mixins: [loadMoreList, commonData],
  components: {
    addEvent: addEvent,
    addCancle: addCancle,
    addManage: addManage,
    signUpTeamList: signUpTeamList
  },
  data: function data() {
    return {
      paramsData: {
        page: 1,
        name: '',
        age_group: ''
      },
      tableData: [],
      total: 0,
      ageGroupList: [],
      formatMap: {
        "league": '联赛制',
        "knockout": '淘汰制',
        "group+knockout": '小组赛+淘汰赛'
      },
      tournamentMap: {
        "official": '正式赛事',
        "friendly": '友谊赛',
        "youth": '青少年赛事'
      }
    };
  },
  created: function created() {
    this.getList();
    this.getAgeGroupListFn();
  },
  // destroyed(){
  //   sessionStorage.removeItem('coachId');
  // },
  methods: {
    getAgeGroupListFn: function getAgeGroupListFn() {
      var _this = this;

      this.$api.ageGroupList().then(function (res) {
        if (res.code == 200) {
          _this.ageGroupList = res.data;
        }
      });
    },
    getList: function getList() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this2.paramsData.page = page;

                _this2.$api.tourList(_this2.paramsData).then(function (res) {
                  if (res.code == 200) {
                    _this2.tableData = res.data.data;
                    _this2.total = res.data.total;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleCancle: function handleCancle(id) {
      this.$refs.addCancle.init(id);
    },
    handleManageInfo: function handleManageInfo(id) {
      this.$refs.addManage.init(id);
    },
    //关闭报名
    closeGenerate: function closeGenerate(id) {
      var _this3 = this;

      this.$confirm("此操作将关闭报名, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$api.closeAndGenerate({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this3.$message.success("关闭报名成功!");

                    _this3.getList(_this3.paramsData.page);
                  } else {
                    _this3.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    handleMange: function handleMange(id) {
      sessionStorage.setItem('coachId', id);
      this.$router.push({
        path: "/eventmanagement/coachmanage",
        query: {
          coachId: id
        }
      });
    }
  }
};